import { CircularProgress, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useOktaAuth } from '@okta/okta-react';
import axios2 from 'axios';
import PropTypes from 'prop-types';
import React, { Suspense, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { renderRoutes } from 'react-router-config';
import { Switch, useHistory } from 'react-router-dom';
import routes from 'src/routes';
import { setIpAddress, setSessionToken, setUserSession, setInformationPopup } from 'src/utils/Common';
import Topbar from './Topbar';
import NotificationSnackbar from '../../components/NotificationSnackbar';
import { store } from '../../store/configureAppStore'

const useStyles = makeStyles((theme) => ({
  container: {
    minHeight: '100vh',
    display: 'flex',
    '@media all and (-ms-high-contrast:none)': {
      height: 0 // IE11 fix
    }
  },
  content: {
    flexGrow: 1,
    maxWidth: '100%',
    overflowX: 'hidden',
    paddingTop: 64,
    [theme.breakpoints.down('xs')]: {
      paddingTop: 56
    }
  }
}));

function Auth() {
  const classes = useStyles();
  const { t } = useTranslation('common');
  const [Loading, setLoading] = React.useState(true);
  const options = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0
  };
  const history = useHistory();
  const { oktaAuth, authState } = useOktaAuth();

  navigator.geolocation.getCurrentPosition(success, error, options);
  function success(pos) {
    // var crd = pos.coords;
  }

  function error(err) {

  }


  useEffect(() => {
    if (!authState.isPending && authState.isAuthenticated) {
      oktaAuth.getUser().then((info) => {
        if (info === undefined) {
          const fromUri = history.createHref(history.location);
          oktaAuth.signInWithRedirect(fromUri);
        }
        const UserNames = info?.preferred_username.split('@');
        const dataUser = [{
          UserName: UserNames[0],
          Password: '',
          TerminalId: '1',
          VersionNr: process.env.REACT_APP_VERSION,
          TerminalIp: '1',
          LanguageId: '1'
        }];

        const configUser = {
          headers: {
            'Content-Type': 'application/json',
            IpAddress: 1,
            'max-age': 86400,
            'X-Frame-Options': 'DENY',
            'X-XSS-Protection': '1; mode=block',
            accessToken: authState.accessToken.accessToken,
            Authorization: `Bearer ${authState.accessToken.accessToken}`,
            Language: localStorage.getItem('i18nextLng')
          }
        };

        const Address = `${process.env.REACT_APP_API_URL}/Technician/GetUserAuthorization`;
        axios2.post(Address, dataUser, configUser)
          .then((response) => {
            setSessionToken(authState.accessToken.accessToken, response.data[0].SessionTokenWs || '');
            setIpAddress(1);
            setUserSession(authState.accessToken.accessToken, response.data[0].SessionTokenWs || '', response.data[0]);
            setLoading(false);
            setLoading(false);
            // history.push('/profile/1/timeline');
            history.push('/overview');
            // setInformationPopup(0);
          }).catch((error) => {
            setLoading(false);
            setInformationPopup(0);
            history.push('/Unauthorized');
          });
      });
    }
    if (!authState.isPending && !authState.isAuthenticated) {
      setInformationPopup(0);
      const fromUri = history.createHref(history.location);
      oktaAuth.signInWithRedirect(fromUri);
    }
  }, [
    authState,
    oktaAuth,
    history
  ]);

  return (
    <>
      <Topbar />
      <div className={classes.container}>
        <div className={classes.content}>
          {Loading
            && (
              <Grid
                container
                spacing={0}
                direction="column"
                alignItems="center"
                justify="center"
                style={{ minHeight: '100vh' }}
              >
                <Typography component="h2" gutterBottom variant="overline">
                  {t('Yonlendiriliyorsunuz')}
                </Typography>
                <CircularProgress disableShrink />
              </Grid>
            )}
          {/* <NotificationSnackbar /> */}
          <Suspense fallback={null}>
            <Switch>{renderRoutes(routes)}</Switch>
          </Suspense>
        </div>
      </div>
    </>
  );
}

Auth.propTypes = {
  route: PropTypes.object
};

export default Auth;
